'use client';

import { recordImpression, recordView } from '@/actions/public/server.actions';
import useUserProfile from '@/hooks/useUserProfile';
import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useInView } from 'react-intersection-observer';

const TrackPostVisibility = ({ post, type, children }) => {
  const user = useUserProfile();
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: false,
  });

  const [isUserReady, setIsUserReady] = useState(false);
  const startTimeRef = useRef(null);
  const hasMountedRef = useRef(false);

  // Function to record view event
  const recordViewEvent = useCallback(
    (duration) => {
      console.log('recordViewEvent', duration);
      if (duration > 3) {
        const payload = {
          type: 'post',
          postId: post.id,
          view: {
            userId: user?.id,
            activeCommunityId: user?.activeCommunity?.id,
            location: user?.location,
            duration: duration.toFixed(2),
          },
        };
        if (user.id > 0) {
          recordView(payload);
        }
      }
    },
    [post.id, user],
  );

  // Function to record impression event
  const recordImpressionEvent = useCallback(() => {
    console.log('recordImpressionEvent');

    const payload = {
      type: 'post',
      postId: post.id,
      impression: {
        userId: user?.id,
        activeCommunityId: user?.activeCommunity?.id,
        location: user?.location,
      },
    };
    if (user.id > 0) {
      recordImpression(payload);
    }
  }, [post.id, user]);

  // Check if user is ready
  useEffect(() => {
    if (user) {
      setIsUserReady(true);
    }
  }, [user]);

  useEffect(() => {
    if (isUserReady && user) {
      // Start tracking only if user is ready
      if (inView) {
        // Record impression only once
        if (!hasMountedRef.current) {
          recordImpressionEvent();
          hasMountedRef.current = true;
        }

        if (!startTimeRef.current) {
          startTimeRef.current = Date.now();
        }
      } else if (startTimeRef.current) {
        const duration = (Date.now() - startTimeRef.current) / 1000;
        recordViewEvent(duration);
        startTimeRef.current = null;
      }

      // // Cleanup on unmount
      // return () => {
      //   if (startTimeRef.current) {
      //     const duration = (Date.now() - startTimeRef.current) / 1000;
      //     recordViewEvent(duration);
      //     startTimeRef.current = null;
      //   }
      // };
    }
  }, [inView, isUserReady, recordImpressionEvent, recordViewEvent, user]);

  // Skip tracking if not on the public type or user is not logged in
  if (type !== 'public' || !user || user.id <= 0) {
    return React.cloneElement(children);
  }

  return React.cloneElement(children, { ref });
};

export default TrackPostVisibility;
